<script>
export default {
    data () {
        return {
            dataTable: [],
            pagination: {
                page: 1,
                rowsPerPage: 10
            }
        }
    },
    computed: {
        headers () {
            return []
        }
    },
    methods: {
        loadDataTable () {
            this.getDataTablePromise().then(
                result => {
                    this.pagination.totalItems = result.data.count
                    this.dataTable = result.data
                },
                this.$appService.handleRequestError(this.$t('canNotLoad', { item: this.$t('data') }))
            )
        },
        getDataTablePromise () {
        }
    },
    watch: {
        pagination () {
            this.loadDataTable()
        }
    }
}
</script>
